import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';
import values from 'lodash/values';
import get from 'lodash/get';

import { parseQueryString } from '../../shared/utils';

import {
  loadPaymentMethodsForAgency,
    createIO,
    updateIO,
  loadIOSForAgency
} from '../../shared/redux/entities/actions';

import {
  loadAccountHistory,
  addFundsToAgency,
    updateIODocuments
} from '../../shared/redux/accounting/actions';
import has from "lodash/has";

function getPaymentMethodsForAgency(state,agencyId){
  if(agencyId){
    return values(state.entities.paymentMethods)
      .filter((p) => p.agencyId === agencyId);
      
  } else {
    return [];
  }
}

function mapStateToProps(state,props){
  const accountId = props.accountId || props.match.params.accountId,
    queryStringParams = parseQueryString(props.location.search),
      historyId = props.match.params.historyId;
  return {
    redirectURL:queryStringParams['redirect'] || null,
    userId:get(state,['entities','activeUserId']),
    accountId:accountId,
    historyId: historyId,
    // historyItem: historyId !== 'new' ? values(get(state,['accounting','accounts',props.accountId,'history'], [])).find((c) => c.id === historyId) : null,
    io: get(state,['entities','ios',historyId], {}),
    isCreate: historyId === 'new',
    paymentMethods:getPaymentMethodsForAgency(state,accountId)
  };
}

function mapDispatchToProps(dispatch){
  //TODO: Bind Redux action creators to AccountNewIO
  return bindActionCreators({ 
    loadPaymentMethodsForAgency,
    loadAccountHistory,
    addFundsToAgency,
    loadIOSForAgency,
    createIO,
    updateIO,
    updateIODocuments
  },dispatch);
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/AccountNewIO/connect.js